import apiRequest from '../apis/api-request';

const dropdownService = {

    userAddorEdit: async () => {
        return apiRequest({
            method: "GET",
            url: `/api/dropdown/useraddoredit`
        });
    },

    inspectorAssignment: async () => {
        return apiRequest({
            method: "GET",
            url: `/api/dropdown/inspectorassignment`
        });
    },

    importCopyQuestionExclude: async ({vessel}) => {
        const vessel_id = vessel ? vessel?.id : null
        return apiRequest({
            method: "GET",
            url: `/api/dropdown/importcopyquestionexclude?vessel_id=${vessel_id}`
        });
    }

};

export default dropdownService;